<div class="container">
	<h2>Get Started</h2>
	<p>
		You’re about to create or edit a rule to check if your assets are missing inspections. Use this rule to define
		when drivers are expected to perform inspections—at the start of duty, end of duty, or both—and how often. Once
		you have the rule created and saved, navigate to View Assets to apply the rule to the intended assets.
	</p>
	<div style="display: flex; gap: 1em" *ngIf="(zoneService.hasOneDivision$ | async) === null">
		<mat-spinner diameter="20" color="accent"></mat-spinner>
		<div>Loading divisions, please wait.</div>
	</div>

	<div class="div-container" [class.invisible]="(showFilter$() | async) === false">
		<div class="label-filter" [class.invisible]="zoneService.hasOneDivision$ | async">
			<div>
				Select the division with the assets you plan to assign rules to:
				<span class="asterisk">*</span>
			</div>
			<app-division-filter-v2 [defaultDivisionId]="defaultDivId"></app-division-filter-v2>
		</div>
	</div>
</div>
